module.exports = __webpack_public_path__ + "img/alerts.cc8692e0.svg";